import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";

import {gpCommon} from "../GasPass";
import {Query} from "../libs/Query";

import icon_arrow_white_up from "../static/icons/icon_arrow_white_up.svg";


let controllerEditFormMap = null;
let controllerEditFormMapMarker = null;

const ControllerEditForm = ({ data, setData, setPopup, setMenu, setNavigation, yandexMapApi }) => {

    const [mapCoordinates, setMapCoordinates] = useState({ latitude: null, longitude: null });
    const [errors, setErrors] = useState( {} );
    const [requireClearMapError, setRequireClearMapError] = useState( false );

    useEffect( () => {

        return () => {
            controllerEditFormMapMarker = null;
            controllerEditFormMap = null;
        }

    }, [] );

    useEffect(() => {
        let mapElement = gpCommon.getElement( 'editMap' );
        if( mapElement !== null ) {

            let mapCenterLatitude = gpCommon.getFloat( mapCoordinates['latitude'], 55.76 );
            let mapCenterLongitude = gpCommon.getFloat( mapCoordinates['longitude'], 37.64 );

            let markerLatitude = gpCommon.getFloat( mapCoordinates['latitude'], null );
            let markerLongitude = gpCommon.getFloat( mapCoordinates['longitude'], null );
            let mapZoom = ( markerLatitude !== null ) && ( markerLongitude !== null ) ? 15 : 10;

            try {
                if( controllerEditFormMap === null ) {
                    controllerEditFormMap = new yandexMapApi.Map( 'editMap', {
                        center: [mapCenterLatitude, mapCenterLongitude],
                        zoom: mapZoom,
                        controls: []
                    }, {
                        suppressMapOpenBlock: true,
                        suppressObsoleteBrowserNotifier: true,
                        yandexMapDisablePoiInteractivity: true
                    });
                    controllerEditFormMap.behaviors.disable([ 'multiTouch', 'rightMouseButtonMagnifier' ]);

                    controllerEditFormMap.events.add( 'click', ( event ) => {
                        try {
                            let coords = event.get( 'coords' );
                            let latitude = gpCommon.getFloat( coords[0], null );
                            let longitude = gpCommon.getFloat( coords[1], null );

                            if( ( latitude !== null ) && ( longitude !== null ) ) {
                                setMapCoordinates( { latitude: latitude, longitude: longitude } );
                                setRequireClearMapError( true );
                            }
                        }
                        catch( e ) {
                            //
                        }
                    });
                }

                if( controllerEditFormMapMarker === null ) {
                    controllerEditFormMapMarker = new yandexMapApi.Placemark(
                        [ markerLatitude, markerLongitude ]
                    );

                    controllerEditFormMap.geoObjects.add( controllerEditFormMapMarker );

                }
                else {
                    controllerEditFormMapMarker.geometry.setCoordinates([ markerLatitude, markerLongitude ]);
                }

            }
            catch( e ) {
                //
            }

        }
    }, [mapCoordinates, yandexMapApi] );

    useEffect( () => {
        if( requireClearMapError ) {

            let newErrors = {};
            let errorKeys = Object.keys( errors );
            if( errorKeys.length > 0 ) {
                for( let errorKey of errorKeys ) {
                    if( errorKey !== 'map' ) {
                        newErrors[errorKey] = errors[errorKey];
                    }
                }
            }
            setErrors( newErrors );

            setRequireClearMapError( false );
        }
    }, [errors, requireClearMapError] );

    return(
        <center>
            <table className="editForm">
                {( ( gpCommon.getString( data['title'], null ) !== null ) || ( gpCommon.getString( data['subtitle'], null ) !== null ) ) && <thead>
                    <tr>
                        <th colSpan="2">{gpCommon.getString( data['subtitle'], gpCommon.getString( data['title'], '' ) )}</th>
                    </tr>
                </thead>}
                {( ( gpCommon.getArray( data['form'], null ) !== null ) || ( gpCommon.getArray( data['button'], null ) !== null ) ) && <tbody>
                    {gpCommon.getArray( data['form'], [] ).map( ( item ) => {

                        if( gpCommon.getString( item['type'], '' ) === 'map' ) {
                            let cellCoordinates = gpCommon.getObject( item['coordinates'], null );
                            if( cellCoordinates !== null ) {
                                let cellLatitude = gpCommon.getFloat( cellCoordinates['latitude'], null );
                                let cellLongitude = gpCommon.getFloat( cellCoordinates['longitude'], null );
                                if( ( cellLatitude !== null ) && ( cellLongitude !== null ) && ( mapCoordinates.latitude === null ) && ( mapCoordinates.longitude === null ) ) {
                                    setMapCoordinates( { latitude: gpCommon.getFloat( cellCoordinates['latitude'], null ), longitude: gpCommon.getFloat( cellCoordinates['longitude'], null ) } );
                                }
                            }

                            return (
                                <tr key={gpCommon.getString( item['id'], '' )}>
                                    <td colSpan="2">
                                        <div id="editMap"></div>
                                        {gpCommon.getString( errors[ gpCommon.getString( item['id'], '' ) ], null ) !== null && <div className="error">{gpCommon.getString( errors[ gpCommon.getString( item['id'], '' ) ], '' )}</div>}
                                    </td>
                                </tr>
                            );
                        }

                        if( gpCommon.getString( item['type'], '' ) === 'separator' ) {
                            return (
                                <tr key={gpCommon.getString( item['id'], '' )}>
                                    <td colSpan="2"><div className="separator"></div></td>
                                </tr>
                            );
                        }

                        if( gpCommon.getString( item['type'], '' ) === 'header' ) {
                            return (
                                <tr key={gpCommon.getString( item['id'], '' )}>
                                    <td colSpan="2"><center className="secondary">{gpCommon.getString( item['header'], '' )}</center></td>
                                </tr>
                            );
                        }

                        return (
                            <tr key={gpCommon.getString( item['id'], '' )}>
                                <td>{gpCommon.getString( item['title'], '' )}
                                    {gpCommon.getString( item['subtitle'], null ) !== null && <br />}
                                    {gpCommon.getString( item['subtitle'], null ) !== null && <span>{gpCommon.getString( item['subtitle'], '' )}</span>}
                                </td>
                                <td>
                                    {gpCommon.getString( item['type'], '' ) == 'select' ? (
                                        <div className="select-wrapper">
                                            <select id={gpCommon.getString( item['id'], '' )}
                                                    className={typeof errors[ gpCommon.getString( item['id'], '' ) ] != "undefined" ? 'error' : undefined}
                                                    defaultValue={gpCommon.getString( item['value'], '' )}
                                                    onChange={onKeyUpInput}
                                                    action-url={gpCommon.getObject( item['action'], null ) ? gpCommon.getString( item['action']['url'], undefined ) : undefined}
                                            >
                                                {gpCommon.getArray( item['options'], [] ).map( ( option ) => {
                                                    return (
                                                        <option key={gpCommon.getString( item['id'], '' ) + gpCommon.getString( option['id'], 'empty' )}
                                                                value={gpCommon.getString( option['id'], '' )}
                                                        >{gpCommon.getString(option['value'], '')}</option>
                                                    );
                                                })}
                                            </select>
                                            <img src={icon_arrow_white_up} />
                                        </div>
                                    ) : (
                                        <input id={gpCommon.getString( item['id'], '' )}
                                               type={gpCommon.getString( item['type'], '' )}
                                               className={typeof errors[ gpCommon.getString( item['id'], '' ) ] != "undefined" ? 'error' : undefined}
                                               placeholder={gpCommon.getString( item['placeholder'], undefined )}
                                               defaultValue={gpCommon.getString( item['value'], '' )}
                                               onKeyUp={onKeyUpInput}
                                               action-url={gpCommon.getObject( item['action'], null ) ? gpCommon.getString( item['action']['url'], undefined ) : undefined}
                                        />
                                    )}
                                    {gpCommon.getString( errors[ gpCommon.getString( item['id'], '' ) ], null ) !== null && <div className="error">{gpCommon.getString( errors[ gpCommon.getString( item['id'], '' ) ], '' )}</div>}
                                </td>
                            </tr>
                        );
                    })}

                    {gpCommon.getArray( data['button'], null ) !== null && <tr><td colSpan="2"><div className="bottomButtons">
                        {gpCommon.getArray( data['button'], [] ).map( ( button ) => {
                            return (
                                <input key={gpCommon.getString( button['id'], '' )} type="button" value={gpCommon.getString( button['value'], '' )} onClick={( e ) => onClickButton( button )} />
                            );
                        })}
                    </div></td></tr>}
                </tbody>}
            </table>
        </center>
    );

    function onClickButton( button ) {
        let buttonAction = gpCommon.getString( button['action'], null );
        if( buttonAction === 'submit' ) {
            if( gpCommon.getObject( errors, null ) === null ) {
                // Submit action
                let submitUrl = gpCommon.getString( button['url'], null );
                if( submitUrl !== null ) {

                    let submitData = {
                        action: 'submit'
                    };

                    {gpCommon.getArray( data['form'], [] ).map( ( item ) => {
                        let itemId = gpCommon.getString( item['id'], null );
                        if( itemId !== null ) {
                            if( itemId === 'map' ) {
                                if( ( gpCommon.getFloat( mapCoordinates['latitude'], null ) !== null ) && ( gpCommon.getFloat( mapCoordinates['longitude'], null ) !== null ) ) {
                                    submitData['latitude'] = mapCoordinates['latitude'];
                                    submitData['longitude'] = mapCoordinates['longitude'];
                                }

                            }
                            else {
                                let itemElement = gpCommon.getElement( itemId );
                                if( itemElement !== null ) {
                                    submitData[itemId] = itemElement.value;
                                }
                            }
                        }
                    })}

                    new Query().get( submitUrl, submitData, ( response ) => {
                        //
                        let responseStatus = gpCommon.getString( response['status'], '' );
                        if( responseStatus === 'ok' ) {
                            // Successful
                            if( typeof response['data'] != "undefined" ) {
                                let data = gpCommon.getObject( response['data'], null );
                                setData( data );
                            }

                            if( typeof response['popup'] != "undefined" ) {
                                let popup = gpCommon.getObject( response['popup'], null );
                                setPopup( popup );
                            }

                            if( typeof response['menu'] != "undefined" ) {
                                let menuData = gpCommon.getArray( response['menu'], null );
                                setMenu( menuData );
                            }

                            if( typeof response['navigation'] != "undefined" ) {
                                let navigation = gpCommon.getArray( response['navigation'], null );
                                setNavigation( navigation );
                            }

                        }
                        else if( responseStatus === 'invalid_params' ) {
                            // Invalid params
                            setErrors( gpCommon.getObject( response['errors'], {} ) );
                        }

                    }, ( error ) => {
                        //
                        if( error.message === 'Not found' )
                        {
                            setData({
                                type: 'notFound',
                                code: '404',
                                description: 'Указанная страница не найдена'
                            })
                        }
                        else if( error.message === 'No response' )
                        {
                            setData({
                                type: 'notFound',
                                code: '408',
                                description: 'Не получен ответ при выполнении запроса'
                            })
                        }
                        else {
                            setData({
                                type: 'notFound',
                                code: '500',
                                description: 'Внутренняя ошибка при выполнении запроса'
                            })
                        }
                        setPopup( null );
                    });
                }
            }

        }
        else if( buttonAction === 'close' ) {
            setPopup( null );
        }
    }

    function onKeyUpInput( e ) {
        try {
            if( typeof e.target.id != "undefined" ) {
                try {
                    if( ( typeof e.target.tagName != "undefined" ) && ( e.target.tagName.toLowerCase() === 'select' ) ) {
                        e.target.blur();
                    }
                }
                catch( e ) {
                    //
                }
                if( typeof errors[ e.target.id ] != "undefined" ) {
                    let isOnlyOneValueMode = true;
                    let errorKeys = Object.keys( errors );
                    if( errorKeys.length > 0 ) {
                        for( let errorKey of errorKeys ) {
                            if( gpCommon.getString( errors[ errorKey ], null ) === null ) {
                                setErrors( {} );
                                isOnlyOneValueMode = false;
                                break;
                            }
                        }
                    }

                    if( isOnlyOneValueMode ) {
                        let newErrors = {};
                        if( errorKeys.length > 0 ) {
                            for( let errorKey of errorKeys ) {
                                if( errorKey !== e.target.id ) {
                                    newErrors[errorKey] = errors[errorKey];
                                }
                            }
                        }
                        setErrors( newErrors );
                    }
                }

                if( typeof e.target.getAttribute( 'action-url' ) !== null ) {

                    let actionUrl = gpCommon.getString( e.target.getAttribute( 'action-url' ), null );
                    if( actionUrl !== null ) {

                        let actionData = {};

                        {gpCommon.getArray( data['form'], [] ).map( ( item ) => {
                            let itemId = gpCommon.getString( item['id'], null );
                            if( itemId !== null ) {
                                if( itemId === 'map' ) {
                                    if( ( gpCommon.getFloat( mapCoordinates['latitude'], null ) !== null ) && ( gpCommon.getFloat( mapCoordinates['longitude'], null ) !== null ) ) {
                                        actionData['latitude'] = mapCoordinates['latitude'];
                                        actionData['longitude'] = mapCoordinates['longitude'];
                                    }

                                }
                                else {
                                    let itemElement = gpCommon.getElement( itemId );
                                    if( itemElement !== null ) {
                                        actionData[itemId] = itemElement.value;
                                    }
                                }
                            }
                        })}

                        new Query().get( actionUrl, actionData, ( response ) => {
                            //
                            let responseStatus = gpCommon.getString( response['status'], '' );
                            if( responseStatus === 'ok' ) {
                                // Successful
                                if( typeof response['data'] != "undefined" ) {
                                    let data = gpCommon.getObject( response['data'], null );
                                    setData( data );
                                }

                                if( typeof response['popup'] != "undefined" ) {
                                    let popup = gpCommon.getObject( response['popup'], null );
                                    setPopup( popup );
                                }

                                if( typeof response['menu'] != "undefined" ) {
                                    let menuData = gpCommon.getArray( response['menu'], null );
                                    setMenu( menuData );
                                }

                                if( typeof response['navigation'] != "undefined" ) {
                                    let navigation = gpCommon.getArray( response['navigation'], null );
                                    setNavigation( navigation );
                                }
                            }

                        }, ( error ) => {
                            //
                        });
                    }
                }
            }
        }
        catch( e ) {
            //
        }
    }

}
ControllerEditForm.propTypes = {
    data: PropTypes.object.isRequired,
    setData: PropTypes.func.isRequired,
    setPopup: PropTypes.func.isRequired,
    setMenu: PropTypes.func.isRequired,
    setNavigation: PropTypes.func.isRequired,
    yandexMapApi: PropTypes.any
};
export default ControllerEditForm;
